import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useNavigate } from 'react-router-dom'

export function DuplicateConfirm() {
  const navigate = useNavigate()
  const closeModal = useAppStore.use.closeModal()
  function handleClickNew() {
    closeModal()
    navigate('/planner/proyectos')
  }

  return (
    <Dialog.Root defaultOpen>
      <Dialog.Portal>
        <Dialog.Content className='dialog white-background absolute left-1/2 top-1/2 z-50 h-16 w-72 -translate-x-1/2 -translate-y-1/2 rounded-2xl border-2 border-C/Color3 bg-C/Color1 p-2 text-left text-xs shadow-xl '>
          <div className='flex flex-col items-center justify-center gap-y-1.5'>
            <p className='font-normal'>{'El diseño se copio con exito'}</p>
            <div className='button container mb-2 flex w-full justify-center'>
              <button
                onClick={handleClickNew}
                className='flex cursor-pointer items-center rounded-xl border border-C/Color7 bg-C/Color3 px-3 py-0.5 text-xs font-normal text-C/Color1'
              >
                {'Ok'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
